module.exports = __webpack_public_path__ + "img/05f_Buy_Scene.f169faac.jpg";